/**
 * @desc 查询中台平台SKU库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuPlatformQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/platform`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
